import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/system/Home.vue'
import Welcome from '../components/system/Welcome.vue'
import Create from '../components/system/eventmanagement/Create.vue'
import Settrack from '../components/system/eventmanagement/Settrack.vue'
import Standard from '../components/system/review/Standard.vue'
import Judges from '../components/system/review/Judges.vue'
import Judgelib from '../components/system/review/Judgelib.vue'
import View from '../components/system/project/View.vue'
import Grouping from '../components/system/project/Grouping.vue'
import Training from '../components/system/video/Training.vue'
import Users from '../components/system/Users.vue'
import School from '../components/system/School.vue'
import RecommendSet from '../components/system/RecommendSet.vue'
import ViewProject from '../components/system/info/ViewProject.vue'
import Progress from '../components/system/info/Progress.vue'
import Ranking from '../components/system/info/Ranking.vue'
import Score from '../components/system/info/Score.vue'
import Article from '../components/system/content/Article.vue'
import Show from '../components/system/content/Show.vue'
import Edit from '../components/system/content/Edit.vue'
import MatchImgList from '../components/system/matchimg/List.vue'
import ReviewSettings from '../components/system/set/ReviewSettings'
import WebSite from '../components/system/set/WebSite'
import Param from '../components/system/set/Param'
import RegisterLoginSettings from '../components/system/set/RegisterLoginSettings'

import ReviewWelcome from '../components/review/ReviewWelcome.vue'
import Workreview from '../components/review/WorkReview.vue'

import Page404 from '../components/Page404.vue'
Vue.use(VueRouter)
// 解决重复点击时报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login, meta: { title: '用户登录' } },
  {
    path: '/system',
    component: Home,
    meta: {
      rolesid: [1]
    },
    redirect: '/welcome',
    children: [
      {
        path: '/welcome',
        component: Welcome,
        meta: {
          rolesid: [1],
          title: '后台首页'
        }
      },
      {
        path: '/createEvent',
        name: '创建赛事',
        component: Create,
        meta: {
          rolesid: [1],
          title: '创建赛事'
        }
      },
      {
        path: '/settrack',
        name: '设置赛道',
        component: Settrack,
        meta: {
          rolesid: [1],
          title: '设置赛道'
        }
      },
      {
        path: '/standard',
        name: '设置评审标准',
        component: Standard,
        meta: {
          rolesid: [1],
          title: '设置评审标准'
        }
      },
      {
        path: '/judges',
        name: '设置评委小组',
        component: Judges,
        meta: {
          rolesid: [1],
          title: '设置评委小组'
        }
      },
      {
        path: '/judgelib',
        name: '赛事评委库',
        component: Judgelib,
        meta: {
          rolesid: [1],
          title: '赛事评委库'
        }
      },
      {
        path: '/view',
        name: '参赛项查看',
        component: View,
        meta: {
          rolesid: [1],
          title: '参赛项查看'
        }
      },
      {
        path: '/grouping',
        name: '作品分配',
        component: Grouping,
        meta: {
          rolesid: [1],
          title: '作品分配'
        }
      },
      {
        path: '/training',
        name: '设置培训视频',
        component: Training,
        meta: {
          rolesid: [1],
          title: '设置培训视频'
        }
      },
      {
        path: '/users',
        name: '会员管理',
        component: Users,
        meta: {
          rolesid: [1],
          title: '会员管理'
        }
      },
      {
        path: '/school',
        name: '学校管理',
        component: School,
        meta: {
          rolesid: [1],
          title: '学校管理'
        }
      },
      {
        path: '/viewProject',
        name: '查看作品',
        component: ViewProject,
        meta: {
          rolesid: [1],
          title: '查看作品'
        }
      },
      {
        path: '/progresss',
        name: '评审进度',
        component: Progress,
        meta: {
          rolesid: [1],
          title: '评审进度'
        }
      },
      {
        path: '/ranking',
        name: '作品排名',
        component: Ranking,
        meta: {
          rolesid: [1],
          title: '作品排名'
        }
      },
      {
        path: '/score',
        name: '作品得分',
        component: Score,
        meta: {
          rolesid: [1],
          title: '作品得分'
        }
      },
      {
        path: '/article',
        name: '文章管理',
        component: Article,
        meta: {
          rolesid: [1],
          title: '文章管理'
        }
      },
      {
        path: '/show',
        name: '文章详情页',
        component: Show,
        meta: {
          rolesid: [1],
          title: '文章详情页'
        }
      },
      {
        path: '/edit',
        name: '修改文章',
        component: Edit,
        meta: {
          rolesid: [1],
          title: '修改文章'
        }
      },
      {
        path: '/matchimglist',
        name: '赛事图片',
        component: MatchImgList,
        meta: {
          rolesid: [1],
          title: '赛事图片'
        }
      },
      {
        path: '/recommendset',
        name: '推荐数设置',
        component: RecommendSet,
        meta: {
          rolesid: [1],
          title: '推荐数设置'
        }
      },
      {
        path: '/reviewsettings',
        name: '会员信息设置',
        component: ReviewSettings,
        meta: {
          rolesid: [1],
          title: '会员信息设置'
        }
      },
      {
        path: '/website',
        name: '站点设置',
        component: WebSite,
        meta: {
          rolesid: [1],
          title: '站点设置'
        }
      },
      {
        path: '/param',
        name: '参数设置',
        component: Param,
        meta: {
          rolesid: [1],
          title: '参数设置'
        }
      },
      {
        path: '/regset',
        name: '注册登录设置',
        component: RegisterLoginSettings,
        meta: {
          rolesid: [1],
          title: '注册登录设置'
        }
      },
      {
        path: '/reviewwelcome',
        name: '评审管理首页',
        component: ReviewWelcome,
        meta: {
          rolesid: [2],
          title: '评审管理首页'
        }
      },
      {
        path: '/workreview',
        name: '作品评审',
        component: Workreview,
        meta: {
          rolesid: [2],
          title: '作品评审'
        }
      }
    ]
  },
  {
    path: '/page404', component: Page404, meta: { title: '404,页面不存在或没有权限' }
  }
]
const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // to 将要访问的路经
  // from 代表从哪个路经跳转而来
  // next 是一个函数，表示放行
  // console.log(from)
  // 添加网页title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()

  const tokenStr = window.localStorage.getItem('token')
  const roleid = window.localStorage.getItem('LoginType')

  if (to.path === '/login') {
    return next()
  }

  if (!tokenStr) {
    return next({ path: '/login' })
  }
  next()
  // 判断角色id是否和当前登录角色id相匹配
  if (to.meta.rolesid !== undefined) {
    if (to.meta.rolesid.includes(parseInt(roleid))) {
      next()
    } else {
      next({ path: '/page404' })
    }
  } else {
    next({ path: '/page404' })
  }
})

export default router
